export default {
	add_playlist: 'Adicionar à playlist',
	audio_save_error: 'Ocorreu um erro ao salvar o áudio',
	audio_save_success: 'Áudio salvo com sucesso',
	audios: 'Audios',
	delete_playlist: 'Apagar Playlist',
	duration: 'Duração',
	episode: 'Episódio',
	episode_plural: 'Episódios',
	favorite_podcast: 'Favoritar Podcast',
	how_do_you_rate_this_podcast: 'Como você avalia este podcast?',
	like_podcast: 'Curtir Podcast',
	listened: 'Ouvido',
	listening: 'Ouvindo',
	loading_podcasts: 'Carregando podcasts',
	new_playlist: 'Criar Playlist',
	new_podcast: 'Novo Podcast',
	no_audios_on_podcast: 'Não existem audios no podcast',
	no_podcasts_are_available_at_the_moment: 'Não há podcasts disponíveis no momento',
	no_podcasts_are_available_with_the_selected_filter:
		'Não há podcasts disponíveis para o filtro selecionado',
	no_podcasts_found: 'Nenhum podcast encontrado',
	no_podcasts_found_with_this_filter: 'Nenhum podcast encontrado com esse filtro',
	only_available_when_finished_podcast: 'Disponível somente após completar o podcast',
	play_sound: 'Reproduzir',
	playlist: 'Playlist',
	playlist_save_success: 'Playlist gravada com sucesso',
	playlists: 'Playlists',
	podcast: 'Podcast',
	podcast_report: 'Relatório de podcasts',
	podcasts: 'Podcasts',
	reviews: 'Avaliações',
	there_are_no_podcasts_avaliable_at_the_moment: 'Não existem podcasts disponíveis no momento',
	to_listen: 'Para ouvir',
	unexpected_error_try_again_later: 'Error inesperado tente novamente mais tarde',
	unfavorite_podcast: 'Desfavoritar Podcast',
	unlike_podcast: 'Descurtir Podcast',
}
